/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Combine_3Inputs */

const en_pc_tut_combine_3 = /** @type {(inputs: Pc_Tut_Combine_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split: divide a document every n pages, or before the pages you choose.`)
};

const zh_pc_tut_combine_3 = /** @type {(inputs: Pc_Tut_Combine_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拆分：每隔 n 页切分文档，或在你指定的页面之前切分。`)
};

/**
* | output |
* | --- |
* | "Split: divide a document every n pages, or before the pages you choose." |
*
* @param {Pc_Tut_Combine_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_combine_3 = /** @type {((inputs?: Pc_Tut_Combine_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Combine_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_combine_3(inputs)
	return zh_pc_tut_combine_3(inputs)
});
export { pc_tut_combine_3 as "pc.tut.combine.3" }